export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./~/d3-path/index.js
// module id = 362
// module chunks = 1